<template>
  <div>
      <div id="photoWrapper" class="big-photo-wrapper">
          <img src="" big-size-photo alt=""/>
          <div class="photo-comment" id="photoComment" v-if="this.orderStatus === OrderStatusEnum.STATUS_CLIENT_REVIEW">
              <h4>Добавить комментарий</h4>
              <c-input save-photo-comment-input class="float-left photo-comment-input"></c-input>
              <c-button save-photo-button class="btn btn-success float-right">Сохранить</c-button>
          </div>
      </div>
    <CModal
        title="Пользовательское соглашение"
        variant="warning"
        :show.sync="downloadModal"
    >
            <span v-if="!submittingError && orderStatus === OrderStatusEnum.STATUS_DL_AVAILABLE">Для просмотра фотографий без защитных водяных знаков, а также для скачивания
                фотографий в полном разрешении вы соглашатесь с тем, что услуга оказана в полном объёме</span>

            <span v-if="!submittingError && orderStatus === OrderStatusEnum.STATUS_CLIENT_REVIEW">Заказ находится на согласовании. После окончательного утверждения фотографии
             будут доступны для просмотра и скачивания без водяных знаков</span>
      <span class="error-message" v-if="submittingError">Внутренняя ошибка на севрере</span>
      <template v-slot:footer>
        <CButton
            color="secondary"
            @click="closeAgreementModal()"
        >Вернуться к просмотру
        </CButton>
        <CButton
            v-if="showDownloadButton"
            color="primary"
            @click="acceptAgreement()"
        >Согласиться с условиями
        </CButton>
      </template>
    </CModal>
    <CModal
        title="Создание архива на скачивание"
        variant="warning"
        :show.sync="archiveCreationStartedDialog"
    >
            <span>Создание архива может занимать до 20 минут. После формирования архива он станет доступен для скачивания в кабинете, а на ваш E-mail будет отправлено письмо
            с прямой ссылкой на архив</span>
      <template v-slot:footer>
        <CButton
            color="primary"
            @click="closeDownloadingModal()"
        >Понятно
        </CButton>
      </template>
    </CModal>
    <CRow>
      <CCol col="12">
        <div class="alert alert-info congratulation" role="alert">
          <p>Благодарим Вас за заказ и, с уверенностью, надеемся, что Ваши фотографии станут прекрасным воспоминанием об
            одном из важнейших событий в Вашей семье!</p>

          <p>С каждым годом, десятилетием, Ваши фотографии приобретут еще большую ценность!</p>
        </div>
        <div class="alert alert-success congratulation" role="alert">
          <p>
            Дополнительно Вы можете заказать фотокнигу размером 20х20см. со скидкой 50%, фотомагниты (очень популярные
            подарки для бабушек и дедушек) и оформленные фотографии для Вашего семейного альбома.
          </p>
          <p>
            Все подробности по тел. <a href="tel:+73912886186" title="Позвонить в Арбат">(391) 28-86-186</a>
          </p>
          <p>
            С наилучшими пожеланиями,
            <br/>
            Команда «Арбат»
          </p>
        </div>
        <div class="alert alert-warning congratulation" role="alert" v-if="needToShowTimeLimitFlag">
          Доступно для скачивания 1 месяц<br/>
          <c-button class="btn btn-success" @click="acceptTimeLimit()">Понятно</c-button>
        </div>
      </CCol>
      <CCol md="12">
        <CCard>
          <CCardHeader class="card-header-title">
            <a href="javascript:void(0)"
               class="back-button"
               v-if="!!this.currentProduction"
               @click="photoBlockClick(null)"
            >
              <CIcon name="cil-arrow-left"/>
              Назад</a>
            Заказ № <span v-if="!authLoading"><b>{{ orderNum }}
                            <span v-if="!!currentProduction">({{ currentProductionName }})</span></b></span>
            <span
                v-else
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true">
                      </span>
          </CCardHeader>
          <CCardBody v-if="!photomarketVCard">
            <div class="content-loader" v-if="orderDataLoading">
                          <span
                              class="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true">
                          </span>
            </div>
            <CRow v-else-if="!currentProduction">
              <CCol xs="6" sm="4" md="4" lg="2" :key="'downloadCol'" v-if="getLoadedProduction().length && showDownloadButton">
                <CCard>
                  <CCardHeader class="card-header-title">
                    <span v-if="archiveCreated">Скачать всё</span>
                    <span v-else-if="archivingInProgress">Создание архива</span>
                    <span v-else>Создать архив для скачивания</span>
                  </CCardHeader>
                  <CCardBody class="photo-block download">
                    <a @click="downloadClick()">
                      <img src="img/profile/download.png" :class="{ hidden: archivingInProgress }" v-if="archiveCreated || archivingInProgress" alt=""/>
                      <img src="img/profile/zip.png" v-else alt=""/>
                      <div v-if="archivingInProgress"
                          class="progress-wrapper"
                      >
                        <span
                            class="progress spinner-border"
                            role="status"
                            aria-hidden="true"></span>
                      </div>
                    </a>
                  </CCardBody>
                </CCard>
              </CCol>
              <CCol xs="6" sm="4" md="4" lg="2" v-for="(item, index) in getLoadedProduction()" :key="index">
                <CCard>
                  <CCardHeader class="card-header-title">
                    {{ item.name }} ({{ item.files ? item.files.length : 0 }})
                  </CCardHeader>
                  <CCardBody class="photo-block">
                    <a href="javascript:void(0)" @click="photoBlockClick(item, $event)">
                      <img src="img/profile/folder.png" alt=""/>
                    </a>
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
            <CRow v-else>
              <CCol col="12" v-if="!this.$dataService.isOrderDownloaded()">
                  <div class="alert alert-warning congratulation" role="alert">
                    Почему я вижу водяные знаки на фотографиях?<br/>
                    <c-button class="btn btn-success" @click="showAgreementModal()">Рассказать</c-button>
                  </div>
              </CCol>
              <CCol xs="6" sm="4" md="4" lg="2" v-for="(item, index) in getImages()" :key="index">
                <CCard>
                  <CCardHeader class="card-header-title">
                    {{ item.name }}
                  </CCardHeader>
                  <CCardBody class="photo-block">
                    <a href="#photoWrapper" :data-fancybox="currentProduction" :data-value="item.id"
                       :data-caption="item.name" @click="clickImage(item)">
                      <img :src="item.preview" alt=""/>
                    </a>
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardBody v-else>
            <CRow>
              <CCol xs="12" lg="5" :key="'downloadCol'" v-if="getLoadedProduction().length">
                <div class="photomarket-download">
                  <a @click="downloadClick()" class="btn btn-info photomarket-download" v-if="archiveCreated">Скачать все фотографии
                    <span
                        style="float: right;"
                        role="status"
                        aria-hidden="true">
                      <img src="img/profile/download.png" alt=""/>
                    </span>
                  </a>
                  <a @click="downloadClick()" class="btn btn-info photomarket-download" v-else-if="archivingInProgress">Создание архива
                    <span
                        class="progress spinner-border"
                        style="color: #000;"
                        role="status"
                        aria-hidden="true"></span>
                  </a>
                  <a @click="downloadClick()" class="btn btn-info photomarket-download" v-else>Скачать все фотографии
                    <span
                        style="float: right;"
                        role="status"
                        aria-hidden="true">
                      <img src="img/profile/zip.png" alt=""/>
                    </span>
                  </a>
                </div>
              </CCol>
              <CCol xs="12" lg="5">
                <form v-if="false" method="post" :action="`https://photomarket.pro/vcards/${this.photomarketVCard}/`" target="_blank" style="height: 100%;">
                  <input type="hidden" name="arbatjwt" :value="this.photomarketJWT"/>
                  <div class="photomarket-download">
                    <input type="submit" class="btn btn-success" value="Перейти к просмотру обработанных фотографий"/>
                  </div>
                </form>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<style>
.photomarket-download {
  padding-bottom: 20px;
}

a.photomarket-download {
  padding-bottom: 0;
  padding-top: 12px;
}

a.photomarket-download span {
  margin-top: -5px;
  max-height: 35px;
}

a.photomarket-download span img {
  max-height: 35px;
}

.photomarket-download, .photomarket-download input {
  width: 100%;
  height: 100%;
  min-height: 50px;
  text-align: left;
  color: #fff;
}

.photomarket-download input {
  height: 100%
}

.download {
  text-align: center;
  position: relative;
}

.download .hidden {
  visibility: hidden;
}

.download .hide {
  display: none;
}

.download:hover {
  cursor: pointer;
}

.download .progress-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -40px;
  margin-top: -40px;
  width: 80px;
  height: 80px;
}

.download .progress-wrapper .progress {
  display: inline-block;
  width: 100%;
  height: 100%;
}

.card-header-title {
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
}

.photo-block img {
  width: 100%;
  height: auto;
}

.content-loader {
  width: 100%;
  text-align: center;
}

.back-button {
  left: 20px;
  position: absolute;
}

.back-button .c-icon {
  margin-top: -3px;
}

.congratulation {
  text-align: center;
  font-weight: bold;
}

.big-photo-wrapper {
    position: relative;
    display: none;
    padding-bottom: 100px;
    background-color: rgba(255, 255, 255, 0.91);
}

.photo-comment {
    position: absolute;
    bottom: 10px;
    width: 500px;
    height: 80px;
    padding: 5px 10px;
    background: white;
    left: 50%;
    margin-left: -250px;
    border-radius: 4px;
}

.photo-comment-input {
    width: 370px;
    position: relative;
}
</style>

<script>
    import { Fancybox } from '@fancyapps/ui';
    import '@fancyapps/ui/dist/fancybox/fancybox.css';
    import { OrderStatusEnum } from '@/lib/common/types/order-status.enum';
    import bootbox from 'bootbox';
    import 'bootstrap';

    export default {
        name: 'Profile',
        components: {},
        data() {
            return {
                orderNum: '',
                orderId: '',
                orderStatus: 0,
                photomarketVCard: '',
                photomarketJWT: '',
                fancyboxShown: false,
                photoComment: '',
                authLoading: false,
                orderDataLoading: false,
                archivingInProgress: false,
                currentProduction: null,
                currentPhoto: {},
                images: [],
                comments: {},
                currentProductionName: '',
                downloadModal: false,
                submittingError: false,
                needToShowTimeLimitFlag: false,
                downloadAfterAgreement: false,
                archiveCreated: false,
                archiveCreationStartedDialog: false,
            };
        },
        methods: {
            async submitComment() {
                const inputCloned = $('#photoWrapper--clone [save-photo-comment-input]');
                const inputInitial = $('#photoWrapper [save-photo-comment-input]');
                const button = $('[save-photo-button]');
                this.currentPhoto.comment = this.currentPhoto.comment !== inputCloned?.val() ? inputCloned.val() : inputInitial.val();

                button.attr('disabled', 'disabled');

                const images = this.$dataService.getImages(this.currentProduction);
                const image = images.find(image => image.id === this.currentPhoto.id);

                const result = await this.$dataService.savePhotoComment(this.currentPhoto.id, this.currentPhoto.comment);

                this.comments[image.id] = this.currentPhoto.comment;

                if (result) {
                    bootbox.alert({
                        title: 'Успех',
                        message: 'Ваш комментарий добавлен к фотографии. Наш оператор учтёт пожелания при обработке заказа',
                    });

                    button.removeAttr('disabled');

                    return;
                }

                button.removeAttr('disabled');

                bootbox.alert({
                    title: 'Ошибка',
                    message: 'Ошибка при сохранении комментария',
                });
            },
            clickImage(img) {
                this.currentPhoto = { ...img };
                setTimeout(() => {
                    $('[save-photo-button]').off('click').on('click', () => this.submitComment());
                    $('[save-photo-comment-input]').val(this.comments[this.currentPhoto.id]);
                    $('[big-size-photo]').attr('src', this.currentPhoto.preview);
                }, 30);
            },
            checkNeedToShowTimeLimit() {
                const alreadyAcceptedRaw = localStorage.getItem('arbatAlreadyAccepted');
                if (alreadyAcceptedRaw) {
                    const parsedFlags = JSON.parse(alreadyAcceptedRaw);
                    if (parsedFlags[this.orderId] || this.orderStatus !== OrderStatusEnum.STATUS_DL_AVAILABLE) {
                        this.needToShowTimeLimitFlag = false;
                        return;
                    }
                }
                this.needToShowTimeLimitFlag = true;
            },
            acceptTimeLimit() {
                const alreadyAcceptedRaw = localStorage.getItem('arbatAlreadyAccepted');
                let currentFlagsState = {};
                if (alreadyAcceptedRaw) {
                    const parsedFlags = JSON.parse(alreadyAcceptedRaw);
                    currentFlagsState = {...parsedFlags};
                }
                currentFlagsState = {...currentFlagsState, [this.orderId]: true};
                localStorage.setItem('arbatAlreadyAccepted', JSON.stringify(currentFlagsState));
                this.needToShowTimeLimitFlag = false;
            },
            closeAgreementModal() {
                this.downloadModal = false;
            },
            showAgreementModal() {
                this.downloadModal = true;
            },
            photoBlockClick(block, e) {
                this.currentProduction = block ? block.id : block;
                this.currentProductionName = block ? block.name : '';
                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            async refreshOrderData() {
                this.orderNum = this.$authService.getOrder();
                this.orderDataLoading = true;
                await this.$dataService.loadData();
                this.values = this.$dataService.getLoadedProduction();
                this.photomarketVCard = this.$dataService.getPhotomarketVCardId();
                this.photomarketJWT = this.$dataService.getPhotomarketJWT();
                this.orderId = this.$dataService.getOrderId();
                this.orderStatus = this.$dataService.getOrderStatus();
                this.orderDataLoading = false;
            },
            getLoadedProduction() {
                return this.$dataService.getLoadedProduction();
            },
            getImages() {
                const images = this.$dataService.getImages(this.currentProduction);
                this.comments = images.reduce((acc, image) => ({ ...acc, [image.id]: image.comment }), {});

                setTimeout(() => {
                    Fancybox.bind('[data-fancybox]', {
                        on: {
                            close: () => this.fancyboxShown = false,
                            'Carousel.change': (fancybox, event) => {
                                const slide = fancybox.getSlide();

                                const id = slide.value;
                                const image = images.find(image => image.id === id);

                                this.currentPhoto = { ...image };
                                $('[save-photo-button]').off('click').on('click', () => this.submitComment());
                                $('[save-photo-comment-input]').val(this.comments[this.currentPhoto.id]);
                                $('[big-size-photo]').attr('src', this.currentPhoto.preview);
                            }
                        }
                    });
                }, 300);

                return images;
            },
            startArchiveProgressPing() {
                const pingInterval = setInterval(async () => {
                    const result = await this.$dataService.checkArchiveCreationProgress();
                    if (!result) {
                        clearInterval(pingInterval);
                        this.checkIfArchiveCreated();
                        this.archivingInProgress = false;
                    }
                }, 2000);
            },
            async download() {
                if (this.archivingInProgress) {
                    return;
                }
                if (this.archiveCreated) {
                    await this.$dataService.getArchive();
                    return;
                }
                this.archivingInProgress = true;
                this.archiveCreationStartedDialog = true;
                await this.$dataService.launchArchiveCreation();
                this.startArchiveProgressPing();
            },
            closeDownloadingModal() {
                this.archiveCreationStartedDialog = false;
            },
            async acceptAgreement() {
                const submittingResult = await this.$dataService.submitDownloading();
                if (submittingResult) {
                    this.closeAgreementModal();
                    await this.$authService.resetToken();
                    await this.$authService.checkAuth();
                    this.refreshOrderData();
                    if (this.downloadAfterAgreement) {
                        this.downloadAfterAgreement = false;
                        return this.download();
                    }
                    return true;
                }
                this.submittingError = true;
            },
            async checkIfArchiveCreated() {
                this.archiveCreated = await this.$dataService.checkIfArchiveCreated();
            },
            downloadClick() {
                this.submittingError = false;
                if (this.$dataService.isOrderDownloaded()) {
                    this.download();
                    return;
                }
                this.downloadAfterAgreement = true;
                this.showAgreementModal();
            },
            backButtonHandler(event) {
                if (this.currentProduction) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.currentProduction = null;
                    return false;
                }
                return true;
            }
        },
        computed: {
            OrderStatusEnum() {
                return OrderStatusEnum;
            },
            showDownloadButton() {
                return [OrderStatusEnum.STATUS_DL_AVAILABLE, OrderStatusEnum.STATUS_FINISH].includes(this.orderStatus);
            },
        },
        async mounted() {
            let authResult = false;
            this.authLoading = true;
            try {
                authResult = await this.$authService.checkAuth();
            } catch (e) {
                authResult = false;
            }
            if (!authResult) {
                this.$authService.logout();
                this.$router.push('/login');
                return;
            }
            this.authLoading = false;
            await this.refreshOrderData();
            this.checkIfArchiveCreated();
            const result = await this.$dataService.checkArchiveCreationProgress();
            if (result) {
                this.archivingInProgress = true;
                this.startArchiveProgressPing();
            }
            this.checkNeedToShowTimeLimit();
        }
    };
</script>
